import React from 'react';
import classnames from 'classnames';

const indicator = (tooltipText, { hasErrors, hasWarnings }) =>
  tooltipText
    ? <div
      className={classnames({
        'with-indicator': true,
        'with-indicator--warning': !hasErrors && hasWarnings,
      })}
      data-tip={tooltipText}
    />
    : null
;

const defaultCellRenderer = ({ value, valueFormatted }) =>
  valueFormatted || value;

const getTooltipText = ({
  withDefaultValueText,
  validationErrorTooltipText,
  validationWarningsTooltipText,
}) => [
  // eslint-disable-next-line no-undefined
  ![undefined, ''].includes(withDefaultValueText) ? `Default value: ${withDefaultValueText}` : '',
  validationErrorTooltipText ? `Validation Errors: ${validationErrorTooltipText}` : '',
  validationWarningsTooltipText ? `Validation Warnings: ${validationWarningsTooltipText}` : '',
].filter(Boolean).join(' ');

export const IndicatorAndCustomInnerRendererCellRenderer = (customInnerRenderer = defaultCellRenderer) => (
  function WithIndicatorCellRenderer(cellData) {
    const { data, colDef } = cellData;
    const { validationMessages, touched, forceShowErrors } = data && data.meta ? data.meta : {};

    const validationErrorTooltipText = validationMessages?.errors?.[colDef.field]
      && (forceShowErrors || (touched && touched[colDef.field]))
      ? validationMessages.errors[colDef.field].join(', ')
      : '';

    const validationWarningsTooltipText = validationMessages?.warnings?.[colDef.field]?.join(', ') ?? '';

    const { overrideConfig } = colDef.customExport || {};

    const source = overrideConfig && data[overrideConfig.sourceField];
    const value = overrideConfig && data[overrideConfig.valueField];

    const hasOverride = overrideConfig && overrideConfig.comparator
      ? !overrideConfig.comparator(source, value)
      : source !== value;

    const formattedSource = overrideConfig && overrideConfig.formatter
      ? overrideConfig.formatter(source)
      : source;

    const withDefaultValueText = hasOverride ? formattedSource : '';

    const tooltipText = getTooltipText({
      withDefaultValueText, validationErrorTooltipText, validationWarningsTooltipText,
    });

    // const indicatorHtml = tooltipText
    //   ? indicator(tooltipText, {
    //     hasErrors: Boolean(validationErrorTooltipText),
    //     hasWarnings: Boolean(validationWarningsTooltipText),
    //   })
    //   : '';

    return (
      <div> {customInnerRenderer(cellData) || ''}
        {indicator(tooltipText, {
          hasErrors: Boolean(validationErrorTooltipText),
          hasWarnings: Boolean(validationWarningsTooltipText),
        })}
      </div>
    );
  }
);

export const withIndicatorAndCustomInnerRendererCellRenderer = columnDefinition => ({
  ...columnDefinition,
  cellRenderer: IndicatorAndCustomInnerRendererCellRenderer(columnDefinition.cellRenderer),
});

const appendCustomRenderer = columnDefs => columnDefs.map(withIndicatorAndCustomInnerRendererCellRenderer);

export default appendCustomRenderer;
